import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Progress from "common/ProgressCircle";
import { getProgressClass } from "lib/util";

export default class MatchScoreInfo extends React.PureComponent {
    static propTypes = {
        matchScore: PropTypes.number.isRequired,
    };

    render() {
        const { matchScore } = this.props;

        return (
            <div className={classNames("match-score__container", getProgressClass(matchScore))}>
                <Progress
                    className="match-score__progress"
                    percentProgress={matchScore}
                    strokeWidth={3}
                    width={140}
                >
                    <div className="match-score__icon-text">
                        <span>Your score</span>
                        <span className="progress-text">{matchScore}%</span>
                    </div>
                </Progress>
                <div className="progress-button" />
                <div className="match-score__content">
                    <strong>What is my Match Score?</strong>
                    <p className="match-score__first-p">
                        Your match score indicates how accurately we predict a job matches what
                        you&apos;re looking for and your previous experience.
                    </p>
                    <p>A high Match Score has the benefits of:</p>
                    <ul>
                        <li>Early access to new roles</li>
                        <li>
                            <strong>Automatically</strong> qualifying you for interviews at jobs
                            where you&apos;re a strong fit (no application required)
                        </li>
                        <li>Better job recommendations</li>
                    </ul>
                </div>
            </div>
        );
    }
}
